/* unplugin-vue-components disabled */import script from "./OfflineStockImport.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineStockImport.vue?vue&type=script&setup=true&lang=js"

import "./OfflineStockImport.vue?vue&type=style&index=0&id=6387ac0f&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6387ac0f"]])

export default __exports__